<script>
	import { fade, draw } from 'svelte/transition';

    export let profile;
</script>

<div class="pic-container">
    <svg class="pic-border" viewBox="0 0 74 100" >
        <path in:draw="{{delay: 1200, duration: 1400}}" d="M 0,0 H 74 V 100 H 0 Z" fill="none" stroke="#3c78d8" stroke-width="3"/>
    </svg>
    <img in:fade="{{delay: 2000, duration: 600}}" class="img-pic" alt="Profile" src={profile.picture}/>
</div>

<style>
    .pic-container {
        position: relative;
        margin:10%;
    }

    .pic-border {
        z-index: 1;
        width: 100%;
    }

    .img-pic {
        position: absolute;
        width: 100%;
        left: 0%;
        z-index: -1;
    }
</style>